<div *ngIf="from && to" class="banner-maintenance">{{'MAINTENANCE.BANNER' | translate:{ from: from | localizedDate:"dd/MM/yyyy HH:mm", to: to | localizedDate:"dd/MM/yyyy HH:mm" } }}</div>
